import interceptor from '@/plugins/interceptor';
const pathController = '/Organization'

export default {
  state: () => ({
    
  }),
  mutations: { 
  },
  actions: {
    async organization_updateLogo(_,img){
      const ret = await interceptor.authenticate.put(`${process.env.VUE_APP_API_ORGANIZATION_URL}${pathController}/updateImage`,img);
      return ret.data;
   }
  }
}